//#region components/combobox/combobox_constants.js
var e = {
	EXTRA_SMALL: "xs",
	SMALL: "sm",
	DEFAULT: "md",
	LARGE: "lg",
	EXTRA_LARGE: "xl"
}, t = { COMBOBOX_LABEL_SIZES: e };
//#endregion
export { e as COMBOBOX_LABEL_SIZES, t as default };

//# sourceMappingURL=combobox-constants.js.map